import http from "../../http";

/**
 * 收银员周期阶梯佣金
 * 网关前缀：/gateway/api/sycompany/pc/cashierCommission
 */
const cashierCommission = {
    planPage(r) {
        return http.get("/gateway/api/sycompany/pc/cashierCommission/plan/page", r)
    },
    planDetail(r) {
        return http.get("/gateway/api/sycompany/pc/cashierCommission/plan/detail", r)
    },
    savePlan(r) {
        return http.confirm.payload("/gateway/api/sycompany/pc/cashierCommission/plan/save", r)
    },
    disablePlan(r) {
        return http.confirm.post("/gateway/api/sycompany/pc/cashierCommission/plan/disable", r)
    },
        realtimeBill(r) {
            return http.get("/gateway/api/sycompany/pc/cashierCommission/bill/realtime", r)
        },
        realtimeBillList(r) {
            return http.get("/gateway/api/sycompany/pc/cashierCommission/bill/realtimeList", r)
        },
        settlePage(r) {
            return http.get("/gateway/api/sycompany/pc/cashierCommission/bill/settlePage", r)
        },
        wallet(r) {
        return http.get("/gateway/api/sycompany/pc/cashierCommission/wallet", r)
    },
    withdrawList(r) {
        return http.get("/gateway/api/sycompany/pc/cashierCommission/withdraw/list", r)
    },
    withdrawApply(r) {
        return http.confirm.payload("/gateway/api/sycompany/pc/cashierCommission/withdraw/apply", r)
    },
    withdrawAudit(r) {
        return http.confirm.payload("/gateway/api/sycompany/pc/cashierCommission/withdraw/audit", r)
    },
    settleRun(r) {
        return http.confirm.post("/gateway/api/sycompany/pc/cashierCommission/settle/run", r)
    },
    reconcileRun(r) {
        return http.confirm.post("/gateway/api/sycompany/pc/cashierCommission/reconcile/run", r)
    }
}

export default cashierCommission
